@if ($reduceOperatorLike(); as reduceOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="reduceOperatorLike" [key]="'attribute'" [label]="'Attribute'"></cm-value-slot>
            <cm-value-slot
                [node]="reduceOperatorLike"
                [key]="'operator'"
                [label]="'Operator'"
                [selectionPossibilities]="reduceOperatorSelectionPossibilities"
            ></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
